import React from 'react';
import { API } from 'app/services';
import { useAsyncTask, useRouter } from 'app/utils';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import MatchDetailCA from './MatchDetailCA';
import MatchDetailDJ from './MatchDetailDJ';
import MatchDetailRegtank from './MatchDetailRegtank';

let mounted = false;

function MatchDetail({ routeType = 'account' }) {
  const router = useRouter();
  const { params } = router.match;
  const screening_id = params.screening_id;
  const match_id = params.match_id;

  const { enqueueSnackbar } = useSnackbar();
  const access = useSelector((state) => state.profile.access);

  const [errorCatcher] = useAsyncTask('getScreening');
  const [runMatchListing] = useAsyncTask('matchListing');

  const [matching, setMatching] = useState(null);
  const [matchProfile, setMatchProfile] = useState(null);

  useEffect(() => {
    mounted = true;
    return () => (mounted = false);
  }, []);

  useEffect(() => {
    if (access?.token) getMatchDetail();
    // eslint-disable-next-line
  }, [access]);

  const getMatchDetail = () => {
    if (!screening_id || !match_id) {
      return enqueueSnackbar('invalid id', { variant: 'error' });
    }

    errorCatcher(async () => {
      const loader =
        routeType === 'account'
          ? API.Screening.get_match_detail
          : API.Admin.get_match;

      const { model } = await loader(screening_id, match_id);

      if (mounted) {
        setMatching(model);

        if (model.profile_retrieved_at && routeType === 'account') {
          loadMatchProfiles();
        }

        if (model.profile_retrieved_at && model.screen_profile) {
          setMatchProfile(model.screen_profile);
        }

        getMatchListing();
      }
    });
  };

  const getMatchListing = (filter = { limit: 1000 }) => {
    runMatchListing(async () => {
      const loader =
        routeType === 'account'
          ? API.Screening.get_matching_list
          : API.Admin.list_match;

      const { models } = await loader(screening_id, filter);

      if (mounted) {
        // optional: store listing if needed
      }
    });
  };

  const loadMatchProfiles = () => {
    if (!screening_id || !match_id) {
      return enqueueSnackbar('invalid id', { variant: 'error' });
    }

    errorCatcher(async () => {
      const { profile } = await API.Screening.get_match_profile(
        screening_id,
        match_id
      );
      setMatchProfile(profile);
    });
  };

  if (!matching) return null;

  if (matching?.screen?.screen_provider_id === 3) {
    return <MatchDetailCA routeType={routeType} />;
  }

  return <MatchDetailRegtank routeType={routeType} />;

    /*
  } else if (matching?.screen?.screen_provider_id === 5) {
    return <MatchDetailRegtank routeType={routeType} />;
  }
    
  
  else {
    return <MatchDetailDJ routeType={routeType} />;
  }
    */
}

export default MatchDetail;